module.exports = __webpack_public_path__ + "static/media/counter.46a9c830.svg";